import { createSelector } from 'reselect';
import { RootState } from 'data'; // Update with your actual import paths
import { HealthPlanState } from './types';

// Base selector for health-plan state
const healthPlanSelector = (state: RootState) => state.healthPlan;

/**
 * Helper function to create memoized selectors for health plan fields
 * @param field - The field to select
 */
const createHealthPlanSelector = <T extends keyof HealthPlanState>(field: T) =>
  createSelector([healthPlanSelector], (healthPlanState) => healthPlanState[field]);

export const selectHealthPlanTab = createHealthPlanSelector('selectedHealthTab');
export const selectHealthPlanType = createHealthPlanSelector('selectedHealthType');
